module.exports = __webpack_public_path__ + "static/media/revenue.dd2ffd70.svg";